import { HttpClient } from '@angular/common/http';
import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { InitialDataService } from 'src/app/services/initialData.service';
import { TenantConfService } from 'src/app/services/tenant-conf.service';
import { NewsletterModalComponent } from './../../../shared/components/newsletter-modal/newsletter-modal.component';
import {TenantEntity, TenantService } from '@syntonize/merlin-core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input()
  iframeURL: any = null;
  @Output()
  scrollToTop = new EventEmitter();

  data$: Observable<any>;
  enabledModules$: Observable<any>;
  tenantLogo$;
  language: string;
  year = new Date().getFullYear();
  footerURL: any;
  intranetURL: any;
  fidelityCardName: any;
  fidelityCardUrl: any;

  employeeLink: any;

  blogLink: any;

  hasOnlyRestoration: any;

  tenantHasCinema: any;

  newsletterInfo$: Observable<any>;

  constructor(
    private initialDataService: InitialDataService,
    public modalController: ModalController,
    public tenantService: TenantService,
    public tenantConfService: TenantConfService,
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
  ) {
    this.footerURL = this.tenantConfService.getFooterLogoURL();
    this.fidelityCardName = this.tenantConfService.getFidelityCardName();
    this.fidelityCardUrl = this.tenantConfService.getFidelityCardUrl();
    this.employeeLink = this.tenantConfService.getEmploymentLink();
    this.blogLink = `${this.tenantConfService.getBlogUrl()}/${this.tenantConfService.getLanguage().toLowerCase()}/`;
    this.hasOnlyRestoration = this.tenantConfService.hasOnlyRestoration();
    this.tenantHasCinema = this.tenantConfService.hasCinema();

  }

  get tenantName() {
    return this.tenantConfService.getTenantNameNoCapitalize();
  }

  get tenantByUrl(){
    return this.tenantConfService.getTenantFromUrl()
  }

  ngOnInit() {
    this.newsletterInfo$ = this.initialDataService.newsletterConfiguration$;
    this.language = this.tenantConfService.getLanguage();
    this.enabledModules$ = this.initialDataService.enabledModules$.pipe(
      map((modules) => modules?.reduce((acc, module) => [...acc, module.name], [])),
      shareReplay()
    );
    this.tenantLogo$ = this.initialDataService.footerLogo$;

    this.data$ = this.tenantService.tenant$.pipe(
        map((tenant: TenantEntity) => {
          this.intranetURL = tenant.intranetUrl
          this.cd.detectChanges()
          return {
            socialMedia: tenant.socialNetworkAndContact,
            centerData: tenant.centerTab['dataSheet'],
          }
        }),
        shareReplay()
    );
  }

  async presentNewsletterModal() {
    const modal = await this.modalController.create({
      component: NewsletterModalComponent,
      cssClass: 'newsletter-modal',
    });
    return await modal.present();
  }

  scrollTop() {
    this.scrollToTop.emit('top');
  }

  isTypeform(iframeURL) {
    if (iframeURL) {
      const data = iframeURL.changingThisBreaksApplicationSecurity.split('.');
      if (data.includes('typeform')) return true;
      else return false
    }
  }

  localizeURL(route) {
    return this.translate.instant(`ROUTES.${route.toUpperCase()}`);
  }
}
